<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <v-card class="d-flex pa-1 bg" outlined>
            <div class="mr-auto d-flex">
              <progress-linear :active="loading"></progress-linear>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-select
                v-model="selectedAnalYmdhms" :items="analYmdhmsList" item-text="label" item-value="time"
                :menu-props="{ offsetY: true }" solo dense hide-details class="mr-1"
                style="width: 300px"
              />
            </div>
            <div>
              <download-button :loading="down.loading" :disabled="down.disabled" @download="download"></download-button>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="5">
          <v-row class="h-100">
            <v-col cols="12">
              <v-card outlined :height="cardHeight">
                <v-card-title>{{ $t('sod.anal.rslt.stts') }}</v-card-title>
                <v-card-text class="content-box" :style="{ height: `${cardHeight - 30}px`, 'overflow-y': 'auto' }">
                  <fieldset>
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <legend><span>{{ $t('sod.anal.general.info') }}</span></legend>
                    <v-row>
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-col cols="3"><p class="label">{{ $t('sod.anal.ymdhms') }}</p></v-col>
                      <v-col cols="9"><v-text-field :value="selected.analYmdhms | format('yyyy-MM-dd HH:mm:ss')" outlined dense hide-details readonly></v-text-field></v-col>
                    </v-row>
                    <v-row>
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-col cols="3"><p class="label">{{ $t('sod.target.sstm') }}</p></v-col>
                      <v-col cols="9"><v-text-field :value="selected.analSstmId" outlined dense hide-details readonly></v-text-field></v-col>
                    </v-row>
                    <v-row>
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-col cols="3"><p class="label">{{ $t('sod.target.mandt') }}</p></v-col>
                      <v-col cols="9"><v-text-field :value="selected.analMandt" outlined dense hide-details readonly></v-text-field></v-col>
                    </v-row>
                    <v-row>
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-col cols="3"><p class="label">{{ $t('sod.anal.type') }}</p></v-col>
                      <v-col cols="3" v-for="(item, idx) in analTypes" :key="idx">
                        <v-checkbox v-model="selected.analType" :label="item.label" :value="item.value" hide-details dense />
                      </v-col>
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-col cols="3"><p class="label">{{ $t('sod.target.role') }}</p></v-col>
                      <v-col cols="4" class="pt-2">
                        <v-checkbox v-model="selected.onlyGenerated" :label="$t('sod.only.generated')" hide-details dense />
                      </v-col>
                      <v-col cols="4" class="pt-2">
                        <v-checkbox v-model="selected.onlyCompared" :label="$t('sod.only.compared')" hide-details dense />
                      </v-col>
                      <v-col cols="1"></v-col>
                    </v-row>
                  </fieldset>
                  <fieldset>
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <legend><span>{{ $t('sod.anal.stts.info') }}</span></legend>
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <v-col cols="2"></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="10"><p><v-icon>mdi-circle-medium</v-icon>{{ $t('sod.ttl.sod.vltn') }}</p></v-col>
                          <v-col cols="12" class="py-3"></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('rtrck.title.srol') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.sodSrolVltnCnt | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('rtrck.title.crol') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.sodCrolVltnCnt | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('rtrck.title.user') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.sodUserVltnCnt | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('sod.tot.vltn.cnt') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.sodVltnTot | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <v-col cols="2"></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="12"><p><v-icon>mdi-circle-medium</v-icon>{{ $t('sod.ttl.ra.vltn') }}</p></v-col>
                          <v-col cols="12" class="py-3"></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('rtrck.title.srol') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.raSrolVltnCnt | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('rtrck.title.crol') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.raCrolVltnCnt | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('rtrck.title.user') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.raUserVltnCnt | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                          <!-- eslint-disable-next-line prettier/prettier -->
                          <v-col cols="6"><p class="label">{{ $t('sod.tot.vltn.cnt') }}</p></v-col>
                          <v-col cols="6"><v-text-field :value="selected.raVltnTot | comma" outlined dense hide-details readonly reverse></v-text-field></v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </fieldset>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="7">
          <v-row class="h-100">
            <v-col cols="12">
              <analyzed-result :analYmdhms="selectedAnalYmdhms" :height="cardHeight" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { format } from 'date-fns';
import { isEmpty } from 'lodash';

import { api } from '@/api/common/instances';
import AnalyzedResult from './AnalyzedResult';

export default {
  components: {
    AnalyzedResult,
  },
  props: {
    height: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      analYmdhmsList: [],
      selectedAnalYmdhms: 0,
      histList: [],
      selected: {},
      down: {
        loading: false,
        disabled: true,
      },
    };
  },
  computed: {
    systemId() {
      return this.$route.params.systemId;
    },
    analTypes() {
      return [
        { label: this.$t('sod.anal.type.A'), value: 'A' },
        { label: this.$t('sod.anal.type.S'), value: 'S' },
        { label: this.$t('sod.anal.type.R'), value: 'R' },
      ];
    },
    cardHeight() {
      return this.height - 54;
    },
  },
  watch: {
    systemId: {
      handler() {
        this.fetchHistories();
      },
    },
    selectedAnalYmdhms: {
      handler(val) {
        this.selected = this.histList.find(hist => hist.analYmdhms == val);
      },
    },
  },
  methods: {
    async fetchHistories() {
      this.laoding = true;
      // eslint-disable-next-line prettier/prettier
      const { data } = await api.get('/sod/dashboard/histories', {
        params: {
          sstmId: this.systemId,
        },
      });
      if (isEmpty(data)) {
        this.$dialog.alert(this.$t('sod.msg.no.dataset'));
        this.down.disabled = true;
        this.histList = [];
        this.selected = {};
        this.analYmdhmsList = [];
        return;
      }
      this.down.disabled = false;
      this.histList = data;
      this.selected = this.histList[0];
      this.analYmdhmsList = data.map(elm => {
        let label = `${this.$t('sod.anal.set')}`;
        label += '  (  ';
        label += `${format(elm.analYmdhms, 'yyyy-MM-dd')}`;
        label += `  -  ${elm.analSstmId}`;
        label += `  -  ${elm.analMandt}`;
        label += '  )';
        return { label, time: elm.analYmdhms };
      });
      this.selectedAnalYmdhms = this.analYmdhmsList[0].time;
      this.loading = false;
    },
    /**
     * 선택된 분석 결과 내역을 엑셀로 다운로드 해준다.
     */
    download() {
      this.down.loading = true;
      const params = {
        sstmId: this.systemId,
        analYmdhms: this.selectedAnalYmdhms,
      };
      // eslint-disable-next-line prettier/prettier
      api.get('/sod/dashboard/excel', { params, responseType: 'blob' })
        .then(({ data, headers }) => {
        let filename = '';
        const disposition = headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
        }
        const type = headers['content-type'];
        const blob = new Blob([data], { type: type });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);
          if (filename) {
            const a = document.createElement('a');
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location = downloadUrl;
          }
          setTimeout(() => URL.revokeObjectURL(downloadUrl), 100); // cleanup
        }
        this.down.loading = false;
      });
    },
  },
  created() {
    this.fetchHistories();
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  margin-top: 10px;
  padding: 10px;
  border-width: 1px;
}
fieldset legend {
  padding: 0px 10px;
}
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
